import { gql } from "@apollo/client";

export const VALIDAR_URGENCIA_VISITA = gql`
    query validarVisitaUrgencia(
        $idEvaluacion: Int!
        $idProfesional: Int!
        $fechaVisita: CustomDateTime!
        $idVisita: Int!
        $idFiguraProfesional: Int!
        $idTipoProfesional: Int!
        $idFrecuencia: Int!
    ){
        validarVisitaUrgencia(
            idEvaluacion: $idEvaluacion 
            idProfesional: $idProfesional 
            fechaVisita: $fechaVisita 
            idVisita: $idVisita 
            idFiguraProfesional: $idFiguraProfesional 
            idTipoProfesional: $idTipoProfesional 
            idFrecuencia: $idFrecuencia 
        ){
            valorEsperado
            success
            error
        }
    }
`;